<style lang="scss" scoped>
  .shop-mobile-block {
    flex: none;
    width: 100%;
    max-width: 600px;

    .title {
      font-size: 32px;
      line-height: 34px;
      text-align: center;
      color: #F5F5F7;
      margin-bottom: 35px;
    }

    .content {
      .content-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &:not(:last-child) {
          margin-bottom: 35px;
        }

        @include media(max, md) {
          width: 100%;
          max-width: 400px;
          display: flex;
          flex-direction: column;
          margin: 0 auto 10px;

          &.shop-games {
            margin-top: 60px;
            margin-bottom: 60px;
            flex-direction: column-reverse;
          }
        }

        .img {
          flex: 1 1 calc(50% - 20px);
          max-width: calc(50% - 20px);
          @include media(max, md) {
            flex: none;
            width: 100%;
            max-width: 100%;
            position: relative;
            &:after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 155px;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, #000000 100%);
            }
          }
        }

        .info {
          flex: 1 1 calc(50% - 20px);
          max-width: calc(50% - 20px);
          display: flex;
          flex-direction: column;
          justify-content: center;
          @include media(max, md) {
            flex: none;
            width: 100%;
            max-width: 100%;
            position: relative;
            margin-top: -40px;
            z-index: 1;
          }
          .subtitle {
            font-weight: 500;
            font-size: 28px;
            line-height: 33px;
            color: #F5F5F7;
            margin-bottom: 10px;
            }
          }
        }

        .link {
          @extend %blue-link-width-arrow;
          span {
            font-size: 20px;
            line-height: 22px;
            @include media(max, lg) {
              font-size: 18px;
            }
          }
        }

        .text {
          font-size: 18px;
          line-height: 1.4;
          color: rgba(white, .76);
          max-width: 280px;
          margin-bottom: 20px;
        }
        &.shop-games .info {
          padding-left: 25px;
        }
  }
}
</style>

<template>
  <div class="shop-mobile-block" id="shop-block">
    <div class="title">{{$t('play')}}</div>
    <div class="content">
      <div class="content-block">
        <div class="img">
          <img :src="`${baseUrl}images/blocks/shop-block/free-game.jpg`"/>
        </div>
        <div class="info">
          <div class="subtitle">{{$t('freeGames')}}</div>
          <div class="text" v-html="$t('freeGamesText', {freeGames: parseInt(this.freeGames / 10, 10) * 10 })"></div>
          <a class="link" :href="playUrl">
            <span>{{$t('link')}}</span>
          </a>
        </div>
      </div>
      <div class="content-block shop-games">
        <div class="info">
          <div class="subtitle">{{$t('shop')}}</div>
          <div class="text" v-html="$t('shopText', {paidGames: parseInt(this.paidGames / 10, 10) * 10})"></div>
          <a class="link" :href="downloadUrl">
            <span>{{$t('link')}}</span>
          </a>
        </div>
        <div class="img">
          <img :src="`${baseUrl}images/blocks/shop-block/shop-games.jpg`"/>
        </div>
      </div>
      <div class="content-block">
        <div class="img">
          <img :src="`${baseUrl}images/blocks/shop-block/cloud-games.png`"/>
        </div>
        <div class="info">
          <div class="subtitle">{{$t('cloud')}}</div>
          <div class="text" v-html="$t('cloudText', {cloudGames: parseInt(this.cloudGames / 10, 10) * 10})"></div>
          <a class="link" :href="cloudGamesUrl">
            <span>{{$t('link')}}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShopMobileBlock',
  i18n: {
    messages: {
      ru: {
        play: 'Играйте',
        freeGames: 'Бесплатные игры',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Более {freeGames} игр<span class="tooltip">В вашем регионе могут быть доступны не все игры</span></b> представлено на&nbsp;платформе.',
        shop: 'Платные игры',
        link: 'Перейти',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Более {paidGames} игр<span class="tooltip">В вашем регионе могут быть доступны не все игры</span></b> от ведущих мировых издателей и разработчиков.',
        cloud: 'Облачные игры',
        cloudText: '<b class="bold-light has-tooltip" flow="up">Более {cloudGames} игр</b> доступных через облако. Играйте в любимые игры в максимальном качестве на любом ПК.',
      },
      en: {
        play: 'Play',
        freeGames: 'Free-to-Play Games',
        freeGamesText:
          'From planet-hopping adventures in the depths of space to daring conquests of medieval worlds, immerse yourself in over <b class="bold-light has-tooltip" flow="up">{freeGames} free games!<span class="tooltip">Some games might be unavailable in your region.</span></b>',
        shop: 'VK Play',
        link: 'Explore',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">{paidGames}+ games<span class="tooltip">Some games might be unavailable in your region</span></b> from the world’s finest gaming studios are ready to play.',
        cloud: 'Cloud gaming',
        cloudText: '<b class="bold-light has-tooltip" flow="up">More than {cloudGames} games</b> available via the cloud. Play your favorite games with maximum quality on any PC.',
      },
      de: {
        play: 'Spielen',
        freeGames: 'Free-to-Play',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Mehr als {freeGames} Spiele<span class="tooltip">Einige Spiele sind in deiner Region eventuell nicht verfügbar</span></b> auf der Plattform verfügbar.',
        shop: 'VK Play',
        link: 'Los',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Mehr als {paidGames} Spiele<span class="tooltip">Einige Spiele sind in deiner Region eventuell nicht verfügbar</span></b> von den weltweit führenden Publishern und Entwicklern.',
        cloud: 'Cloud Gaming',
        cloudText: '<b class="bold-light has-tooltip" flow="up">Mehr als {cloudGames} Spiele</b> via Cloud verfügbar. Spielen Sie Ihre Lieblingsspiele in maximaler Qualität auf jedem PC.',
      },
      fr: {
        play: 'Jouez',
        freeGames: 'Gratuits',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Plus de {freeGames} jeux vous<span class="tooltip">Il se peut que certains jeux soient indisponibles dans votre région</span></b> attendent sur la plateforme.',
        shop: 'Magasin de jeux',
        link: 'Accéder',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Plus de {paidGames} jeux<span class="tooltip">Il se peut que certains jeux soient indisponibles dans votre région</span></b> des meilleurs développeurs et éditeurs du monde entier.',
        cloud: 'Jeux sur Cloud',
        cloudText: '<b class="bold-light has-tooltip" flow="up">Plus de {cloudGames} jeux</b> disponibles via le Cloud. Jouez à vos jeux préférés en qualité maximale sur n\'importe quel PC.',
      },
      es: {
        play: 'Jugar',
        freeGames: 'Juego gratuito',
        freeGamesText:
          'Te esperan <b class="bold-light has-tooltip" flow="up">más de {freeGames} juegos<span class="tooltip">Puede que algunos juegos no estén disponibles en tu región</span></b> en la plataforma.',
        shop: 'Tienda',
        link: 'Ir Tienda',
        shopText:
          'Hay <b class="bold-light has-tooltip" flow="up">más de {paidGames} juegos<span class="tooltip">Puede que algunos juegos no estén disponibles en tu región</span></b> de las mejores empresas y desarrolladoras del mundo.',
        cloud: 'Juegos en la nube',
        cloudText: '<b class="bold-light has-tooltip" flow="up">Más de {cloudGames} juegos</b> disponibles en la nube. Juega tus juegos favoritos con la máxima calidad en cualquier PC.',
      },
      tr: {
        play: 'Oyna',
        freeGames: 'Oynaması ücretsiz',
        freeGamesText:
          'Platformda <b class="bold-light has-tooltip" flow="up">{freeGames}\'den fazla oyun<span class="tooltip">Bazı oyunlar bölgende uygun olmayabilir</span></b> var.',
        shop: 'Game Store',
        link: 'Git',
        shopText:
          'Dünyaca ünlü yayıncılar ve geliştiricilerden <b class="bold-light has-tooltip" flow="up">{paidGames}\'den fazla oyun<span class="tooltip">Bazı oyunlar bölgende uygun olmayabilir.</span></b>',
        cloud: 'Bulut oyunları',
        cloudText: '<b class="bold-light has-tooltip" flow="up">Bulutla oynanabilecek {cloudGames} sayısından fazla oyun.</b> En sevdiğiniz oyunları herhangi bir bilgisayarda maksimum kalitede oynayın.',
      },
      pl: {
        play: 'Graj',
        freeGames: 'Darmowe',
        freeGamesText:
          '<b class="bold-light has-tooltip" flow="up">Ponad {freeGames} gier<span class="tooltip">Niektóre gry mogą nie być dostępne w twoim regionie</span></b> dostępnych na platformie.',
        shop: 'Sklep gier',
        link: 'Idź',
        shopText:
          '<b class="bold-light has-tooltip" flow="up">Ponad {paidGames} gier<span class="tooltip">Niektóre gry mogą nie być dostępne w twoim regionie</span></b> od wiodących na świecie producentów oraz twórców.',
        cloud: 'Granie w chmurze',
        cloudText: '<b class="bold-light has-tooltip" flow="up">Dzięki chmurze możesz się cieszyć ponad {cloudGames} grami.</b> Graj w swoje ulubione gry w maksymalnej jakości na dowolnym komputerze.',
      },
      ar: {
        play: 'لعب',
        freeGames: 'ألعاب مجانية',
        freeGamesText:
          '<span>من مغامرات التنقل بين الكواكب في أعماق الفضاء حتى غزوات العصور الوسطى </span> <b class="bold-light has-tooltip" flow="up">،لعبة مجانية {freeGames}<span class="tooltip">قد لا تكون بعض الألعاب متوفرة في منطقتك</span></b> اغمر نفسك في أكثر من',
        shop: 'متجر VK Play',
        link: 'استكشاف',
        shopText:
          '<span>الاستوديوهات العالمية لتطوير الألعاب جاهزة للعب</span> <b class="bold-light has-tooltip" flow="up">لعبة {paidGames}<span class="tooltip">قد لا تكون بعض الألعاب متوفرة في منطقتك</span></b> أكثر من',
        cloud: 'الألعاب السحابية',
        cloudText: '<span>متوفرة عبر السحابة. العب ألعابك المفضلة بأعلى مستوى من الجودة على أي جهاز كمبيوتر</span> <b class="bold-light">لعبة {cloudGames} أكثر من</b>',
      },
    },
  },
  props: {
    freeGames: {
      type: Number,
      default: 0,
    },
    paidGames: {
      type: Number,
      default: 0,
    },
    cloudGames: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    playUrl() {
      return '//vkplay.ru/play/is_free/';
    },
    downloadUrl() {
      return '//vkplay.ru/play/is_sellable/';
    },
    cloudGamesUrl() {
      return '//vkplay.ru/play/is_cloud/';
    },
  },
};

</script>
